// extracted by mini-css-extract-plugin
export default {"container":"Lq-z","heading":"Mq-z","text":"Nq-z","info":"Oq-z","link":"Pq-z","fullMaxWidth":"Qq-z"};